import type { HTMLAttributes, ReactNode, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import { cn } from './cn.js';

/** Tabulas čaula: apmale + noapaļojums + horizontālā ritināšana + lipīga galvene. */
export function TableShell({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'overflow-x-auto rounded-xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900',
        className,
      )}
    >
      <table className="w-full text-left text-sm">{children}</table>
    </div>
  );
}

export function THead({ children }: { children: ReactNode }) {
  return (
    <thead className="sticky top-0 border-b border-slate-200 bg-slate-50 text-xs uppercase tracking-wide text-slate-500 dark:border-slate-800 dark:bg-slate-950/60 dark:text-slate-400">
      {children}
    </thead>
  );
}

export function Th({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) {
  return <th className={cn('px-4 py-3 font-semibold', className)} {...props} />;
}

export function Td({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={cn('px-4 py-3 align-middle text-slate-700 dark:text-slate-300', className)}
      {...props}
    />
  );
}

export interface TrProps extends HTMLAttributes<HTMLTableRowElement> {
  /** Klikšķināma rinda (hover + kursors + fokusa stils). */
  interactive?: boolean;
}

export function Tr({ interactive, className, ...props }: TrProps) {
  return (
    <tr
      className={cn(
        'border-b border-slate-100 last:border-0 dark:border-slate-800/60',
        interactive &&
          'cursor-pointer transition-colors hover:bg-slate-50 focus-visible:bg-slate-50 dark:hover:bg-slate-800/50',
        className,
      )}
      tabIndex={interactive ? 0 : undefined}
      {...props}
    />
  );
}
